import { render } from "./SpotPageMenu.vue?vue&type=template&id=2d1164d2&scoped=true"
import script from "./SpotPageMenu.vue?vue&type=script&lang=js"
export * from "./SpotPageMenu.vue?vue&type=script&lang=js"

import "./SpotPageMenu.vue?vue&type=style&index=0&id=2d1164d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1164d2"]])

export default __exports__